import React, { useEffect, useState } from "react";
import { Form, Checkbox, Button, message } from "antd";
import axios from "axios";
import { SetCarrito } from "../../../Hooks/Carrito";

const DiscountInput = (props) => {

  const { venta_id, setLoading = () => {} } = props;

  const setCart = React.useContext(SetCarrito)

  const [form] = Form.useForm();
  const [checked, setChecked] = useState(false);
  const [discountDisponible,  setDiscountDisponible] = useState(false)

  const onFinish = (values) => {
    console.log("Valores enviados:", values);
  };

   //Obtiene la venta del cliente
   const getVenta = async () => {
    try{
      let {data} = await axios.get('/customer/venta',{
        params:{
          venta_id: venta_id
        }
      })
      if(data.discount){
        console.log(data.discount)
        form.setFieldValue("use_discount", true)
      }
    }catch(e){
      console.log(e)
    }
  }

  //indica si el cliente puede aplicar a un descuento
  const getDiscount = async () => {
    try{
      let {data} = await axios.get('/customer/discounts')
      console.log(data)
      setDiscountDisponible(data)
    }catch(e){
      console.log(e)
    }
  }

  //aplica el descuento a la venta
  const setDiscount = async (e) => {
    try{
      setChecked(e.target.checked)
      setLoading(true)
      let { data } = await axios.post('/customer/discounts',{
        aplicar: e.target.checked,
        venta_id: venta_id,
      })
      console.log(data)
      console.log("exito")
      setCart(data)
    }catch(error){
      message.error("Error applying the discount")
    }finally{
      setLoading(false)
    }

  }

  useEffect(()=>{
    if (venta_id){
      getDiscount();
      getVenta()
    }
  }, [venta_id])
  
  if(!discountDisponible) return null;

  return (
    <Form form={form} onFinish={onFinish} layout="vertical">
      <Form.Item
        name="use_discount"
        valuePropName="checked"
        className="m-0"
      >
        <Checkbox checked={checked} onChange={setDiscount}>
          Use available discount (-50%)
        </Checkbox>
      </Form.Item>
    </Form>
  );
};

export default DiscountInput;
